import React, { useState, useEffect } from 'react';
import '../../styles/OurRecruiters.css';
import { getAllPackages } from '../../services/getAllApi';

const OurRecruiters = () => {

  const [packages, setPackages] = useState({
    highest: "0.00",
    average: "0.00",
    minimum: "0.00"
  });

  // Fetching package data from API
  useEffect(() => {
    getAllPackages().then((res) => {

      if (res.status === 200) {
        const packageData = res.data.data;
        const highest = packageData.find((pkg) => pkg.package_type === 'highest');
        const average = packageData.find((pkg) => pkg.package_type === 'average');
        const minimum = packageData.find((pkg) => pkg.package_type === 'minimum');

        // Set package values in state
        setPackages({
          highest: highest ? highest.amount : "0.00",
          average: average ? average.amount : "0.00",
          minimum: minimum ? minimum.amount : "0.00"
        });
      }
    }).catch(error => {
      console.error("Error fetching packages:", error);
    });
  }, []);

  return (
    <div className="containerrr">
      <div className='head_container'>
        <div className="line"></div>
        <h2 className="title">Our Recruiters</h2>
      </div>

      <div className="recruiters-container">
        <div className="center-logo flex justify-center mb-8 hidden sm:block">
          <img src="recruiters_logos/finxl.png" alt="FBS Logo" className="logo-image mx-auto " />
        </div>

        {/* Original circular layout - unchanged */}
        <div className="recruiters-circle hidden lg:block ">
          <div className="recruiter-logo ">
            <img src="recruiters_logos/hitachi.png" alt="Hitachi" id="hitachi_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/Northern_Trust-Logo.wine.svg" alt="Northern Trust" id="northen_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/Deloitte-Logo.wine.svg" alt="Deloitte" id="dello_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/J_P_Morgan1.svg" alt="J.P. Morgan" id="jp_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/Daloopa.png" alt="Moody's Analytics" id="moddy_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/upl.png" alt="UPL" id="upl_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/Infosys_logo.svg" alt="Infosys" id="info_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/Tech_Mahindra-Logo.wine.svg" alt="Tech Mahindra" id="techm_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/kpmg.png" alt="KPMG" id="kpmg_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/cap.svg" alt="Capgemini" id="cap_img" />
          </div>
          <div className="recruiter-logo">
            <img src="recruiters_logos/accenture.png" alt="Accenture" id="accenture_img" />
          </div>
        </div>

        {/* Mobile layout with no right overflow */}
        <div className="lg:hidden w-full mb-12 sm:scale-900" id="or">
          <div className="mx-auto w-[75%] sm:w-[20rem] grid grid-cols-1 gap-1 sm:gap-[0.24rem]">
            <div className='flex-row  relative  sm:right-[1rem] grid grid-cols-3 gap-[1rem]'>
              <div className="flex justify-center ">
                <img src="recruiters_logos/hitachi.png" alt="Hitachi" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/Northern_Trust-Logo.wine.svg" alt="Northern Trust" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/Deloitte-Logo.wine.svg" alt="Deloitte" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/J_P_Morgan1.svg" alt="J.P. Morgan" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/Daloopa.png" alt="Moody's Analytics" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/upl.png" alt="UPL" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/Infosys_logo.svg" alt="Infosys" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/Tech_Mahindra-Logo.wine.svg" alt="Tech Mahindra" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/kpmg.png" alt="KPMG" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/cap.svg" alt="Capgemini" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/accenture.png" alt="Accenture" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
              <div className="flex justify-center">
                <img src="recruiters_logos/TCS_NewLogo.png" alt="Accenture" className="w-4.5rem sm:w-16 h-2.5rem sm:h-16 object-contain" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="packages-container" id="bx">
        <div className="package-box highest same">
          <div className="package-value">INR<strong>{packages.highest}</strong>LPA</div>
          <div className="package-label">HIGHEST PACKAGE</div>
        </div>
        {/* <div className="package-box average">
              <div className="package-value">INR<strong>{packages.average}</strong>LPA</div>
              <div className="package-label">AVERAGE PACKAGE</div>
            </div> */}
        <div className="package-box minimum same">
          <div className="package-value">INR<strong>{packages.average}</strong>LPA</div>
          <div className="package-label">AVERAGE PACKAGE</div>
        </div>
      </div>
    </div>
  );
}

export default OurRecruiters;





